import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState } from "react"
import _ from "underscore";
import * as Icons from '@fortawesome/free-regular-svg-icons';

export const usePreviewSurvey = ({ surveyData }) => {

    const [previewData, setPreviewData] = useState({ data: [], view_section_wise: false, thank_you_template: "", data_length: 0, rating_data: {}, loader: false });
    const [activeStep, setActiveStep] = useState(0);

    useEffect(() => {
        if (!_.isEmpty(surveyData)) {
            handleFormatting();
        }
    }, [surveyData])

    const handleFormatting = () => {
        setPreviewData((prev) => ({ ...prev, loader: true }));
        const sortedCategory = _.sortBy(surveyData?.survey_question_details, "category_order_number");

        const surveyInfo = surveyData?.survey_details?.[0];
        const questionsData = _.sortBy(_.filter(sortedCategory, quest => quest?.category_order_number > 0)?.concat(_.filter(sortedCategory, quest => quest?.category_order_number === 0)), "question_order_number");
        const data = _.groupBy(_.filter(questionsData, quest => quest?.question_order_number > 0)?.concat(_.filter(questionsData, quest => quest?.question_order_number === 0)), "question_category_name");
        let dataObj = {}

        Object.entries(data)?.forEach(([key, value]) => {
            dataObj[key] = [];
            value?.forEach(item => {
                let dataItem = { ...item };
                if (item?.question_type_key === "choice") {
                    const filtered = _.filter(value, quest => quest?.question_id === item?.question_id);
                    const options = _.pluck(filtered, "option_text");
                    dataItem = { ...item, options }
                }
                if (_.isEmpty(_.findWhere(dataObj[key], { question_id: dataItem?.question_id }))) {
                    dataObj[key].push(dataItem);
                }
            })
        })

        setPreviewData((prev) => ({ ...prev, data: dataObj, view_section_wise: surveyInfo?.is_section_view || false, thank_you_template: surveyInfo?.template_name1, data_length: Object.keys(data)?.length }));

        setTimeout(() => {
            setPreviewData((prev) => ({...prev, loader: false}));
        }, 200)
    }

    const getRatingIcons = (symbolKey, key) => {
        const icons = {
            'star': {
                off: <FontAwesomeIcon className="c-pointer" icon={Icons?.faStar} style={{ color: "#bcc1c6" }} />,
                on: <FontAwesomeIcon className="c-pointer" icon="fa-solid fa-star" style={{ color: "#facc15" }} />
            },
            'heart': {
                off: <FontAwesomeIcon className="c-pointer" icon={Icons?.faHeart} style={{ color: "#bcc1c6" }} />,
                on: <FontAwesomeIcon className="c-pointer" icon="fa-solid fa-heart" style={{ color: "#facc15" }} />
            },
            'trophy': {
                off: <FontAwesomeIcon className="c-pointer" icon="fa-solid fa-trophy" style={{ color: "#bcc1c6" }} />,
                on: <FontAwesomeIcon className="c-pointer" icon="fa-solid fa-trophy" style={{ color: "#facc15" }} />
            },
            'check': {
                off: <FontAwesomeIcon className="c-pointer" icon={Icons?.faCircleCheck} style={{ color: "#bcc1c6" }} />,
                on: <FontAwesomeIcon className="c-pointer" icon="fa-solid fa-circle-check" style={{ color: "#facc15" }} />,
            },
            'badge': {
                off: <FontAwesomeIcon className="c-pointer" icon={Icons?.faCircle} style={{ color: "#bcc1c6" }} />,
                on: <FontAwesomeIcon className="c-pointer" icon="fa-solid fa-circle" style={{ color: "#facc15" }} />,
            },
        };
        return icons[symbolKey]?.[key] || <FontAwesomeIcon className="c-pointer" icon={Icons?.faStar} style={{ color: "#bcc1c6" }} />;
    };

    return useMemo(() => ({
        previewData, setPreviewData, activeStep, setActiveStep, getRatingIcons
    }), [previewData, setPreviewData, activeStep, setActiveStep, getRatingIcons])
}